"use client";

import { FC } from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import { Collapse } from "../Collapse";
import { FAQSectionProps } from "./types";
import { convertLinksToClickable } from "@utils";

export const FAQSection: FC<FAQSectionProps> = ({ items, className }) => {
  const data = items.map((item, index) => ({
    key: String(index),
    label: item.question,
    children: convertLinksToClickable(item.answer),
  }));

  return (
    <Collapse
      data={data}
      accordion={true}
      expandIcon={({ isExpanded }) => (
        <Icon
          name="plus"
          size={20}
          className={cn(
            "transition-transform duration-300 ease-in-out text-content_brand_primary duration-200 transition-all group-hover:text-content_brand_secondary",
            isExpanded ? "rotate-45" : "rotate-0",
          )}
        />
      )}
      classNames={{
        headerLabel:
          "body_medium_l text-content_primary duration-200 transition-all group-hover:text-content_secondary",
        content: "body_m text-content_secondary",
      }}
      className={className}
    />
  );
};
